export const FETCH_FOODCOURT_RESTAURANTS_REQUEST = 'FETCH_FOODCOURT_RESTAURANTS_REQUEST';
export const FETCH_FOODCOURT_RESTAURANTS_SUCCESS = 'FETCH_FOODCOURT_RESTAURANTS_SUCCESS';
export const FETCH_FOODCOURT_RESTAURANTS_FAILURE = 'FETCH_FOODCOURT_RESTAURANTS_FAILURE';
